<template>
  <div class="app-container gamesIndex">
    <el-card class="tabBox">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="全部赛事" name="all"></el-tab-pane>
        <el-tab-pane label="待审核赛事" name="port"></el-tab-pane>
        <el-tab-pane label="通过的赛事" name="wechat"></el-tab-pane>
        <el-tab-pane label="拒绝的赛事" name="invite"></el-tab-pane>
      </el-tabs>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addGame"
        class="mb20"
        >添加赛事</el-button
      >
      <el-form
        :model="queryParams"
        ref="queryForm"
        :inline="true"
        size="small"
        class="box_form"
      >
        <el-form-item label="赛事名称" prop="gameName">
          <el-input
            v-model="queryParams.gameName"
            placeholder="请输入赛事名称"
            clearable
            @keyup.enter.native="handleQuery"
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="发布人" prop="userName">
          <el-input
            v-model="queryParams.userName"
            placeholder="请输入发布者姓名"
            clearable
            @keyup.enter.native="handleQuery"
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="赛事类型" prop="gameTypeId">
          <el-select
            v-model="queryParams.gameTypeId"
            placeholder="赛事类型"
            clearable
            filterable
            @change="$forceUpdate()"
          >
            <el-option
              v-for="(item, index) in types"
              :key="index"
              :label="item.gameTypeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="比赛进度" prop="state">
          <el-select
            filterable
            v-model="queryParams.state"
            placeholder="比赛进度"
            clearable
            @change="$forceUpdate()"
          >
            <el-option
              v-for="(item, index) in status"
              :key="index"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="报名时间" prop="applyTime">
          <el-date-picker
            v-model="queryParams.applyTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="报名时间"
            end-placeholder="报名时间"
            @change="$forceUpdate()"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="比赛时间" prop="gameTime">
          <el-date-picker
            v-model="queryParams.gameTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="比赛时间"
            end-placeholder="比赛时间"
            @change="$forceUpdate()"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="提交时间" prop="time">
          <el-date-picker
            v-model="queryParams.time"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="提交时间"
            end-placeholder="提交时间"
            @change="$forceUpdate()"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh-left" @click="resetQuery"
            >重置</el-button
          >
          <el-button icon="el-icon-download" @click="handleExport"
            >导出数据</el-button
          >
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" element-loading-text="加载中" :data="list">
        <el-table-column
          label="编号"
          align="center"
          type="index"
          width="50"
          fixed="left"
        />
        <el-table-column
          label="赛事名称"
          align="center"
          prop="gameName"
          width="140"
          fixed="left"
        />
        <el-table-column
          label="赛事封面图"
          align="center"
          prop="gameImg"
          width="140"
          fixed="left"
        >
          <template slot-scope="scope">
            <el-image
              fit="contain"
              class="tableImg"
              :src="scope.row.gameImg"
              :preview-src-list="[scope.row.gameImg]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="赛事类型"
          align="center"
          prop="typeName"
          width="180"
        />
        <!-- <el-table-column label="赛事项目" align="center" prop="itemName" width="120"/> -->
        <!-- <el-table-column label="审核状态" align="center" prop="memberType" width="120">
					<template slot-scope="scope">
						<span class="statusTag warn" v-if="scope.row.isCheck == '1'"> 待审核 </span>
						<span class="statusTag danger" v-if="scope.row.isCheck == '2'"> 审核拒绝 </span>
						<span class="statusTag success" v-if="scope.row.isCheck == '3'"> 审核通过 </span>
					</template>
				</el-table-column> -->
        <!-- <el-table-column label="赛事进度" align="center" prop="userStatus" width="120">
					<template slot-scope="scope">
						<span class="statusTag gray" v-if="scope.row.state == '1'&& scope.row.isCheck != '1'"> 已结束
						</span>
						<span class="statusTag success"
							v-else-if="scope.row.state == '2' && scope.row.isCheck != '1'">进行中 </span>
						<span class="statusTag primary" v-else-if="scope.row.state == '3'&& scope.row.isCheck != '1'">
							报名中 </span>
						<span class="primary" v-else> - </span>
					</template>
				</el-table-column> -->
        <el-table-column
          label="赛事人数"
          align="center"
          prop="isLimit"
          width="120"
        ></el-table-column>
        <el-table-column
          label="报名时间"
          align="center"
          prop="userStatus"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              {{ parseTime(scope.row.applyStartTime, "{y}-{m}-{d} {h}:{i}") }}
            </div>
            <div>——</div>
            <div>
              {{ parseTime(scope.row.applyEndTime, "{y}-{m}-{d} {h}:{i}") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="比赛时间"
          align="center"
          prop="userStatus"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              {{ parseTime(scope.row.gameStartTime, "{y}-{m}-{d} {h}:{i}") }}
            </div>
            <div>——</div>
            <div>
              {{ parseTime(scope.row.gameEndTime, "{y}-{m}-{d} {h}:{i}") }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="举办地点" align="center" prop="provinceName"></el-table-column> -->
        <el-table-column
          label="发布人"
          align="center"
          prop="userStatus"
          width="180"
        >
          <template slot-scope="scope">
            <div class="flxCC">
              <el-avatar :src="scope.row.avatarUrl" class="mr10"></el-avatar>
              <span>{{ scope.row.userName }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否显示在前端" align="center" prop="userStatus" width="150">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.isEnable" active-value="1" inactive-value="0"
							@change="_switchGame(scope.row)"></el-switch>
					</template>
				</el-table-column> -->

        <el-table-column
          label="提交时间"
          align="center"
          prop="createTime"
          width="150"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="220"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleDtl(scope.row)"
              >详情</el-button
            >
            <el-button
              size="small"
              plain
              type="primary"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              plain
              type="danger"
              @click="handleDel(scope.row)"
              v-if="scope.row.isCheck == '1' || scope.row.isCheck == '2'"
              >删除</el-button
            >
            <br />
            <el-button
              size="small"
              plain
              type="success"
              style="margin-top: 10px"
              @click="gameSum(scope.row)"
              >赛事总结</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="_getList"
      />
    </el-card>

    <el-dialog
      title="审核赛事"
      :visible.sync="dialogShow"
      width="600px"
      append-to-body
    >
      <el-form ref="setform" :model="setParams" size="mini">
        <el-form-item label="" prop="isCheck">
          <el-radio-group v-model="setParams.isCheck">
            <el-radio label="3">审核通过</el-radio>
            <el-radio label="2">审核拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label=""
          prop="checkRemark"
          v-if="setParams.isCheck == '2'"
        >
          <el-input
            :rows="5"
            type="textarea"
            maxlength="20"
            placeholder="填写拒绝原因"
            show-word-limit
            v-model="setParams.checkRemark"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="dialogShow = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="赛事总结"
      :visible.sync="dialogShowGameSum"
      width="800px"
      append-to-body
    >
      <el-form
        ref="gameSumForm"
        :rules="gameSumFormRules"
        :model="gameInfo"
        size="mini"
      >
        <el-form-item
          label=""
          prop="gameCompetitionSystem"
        >
          <el-input
            :rows="5"
            type="textarea"
            maxlength="20"
            placeholder="填写赛事总结内容"
            show-word-limit
            v-model="gameInfo.gameCompetitionSystem"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormGameSum">确 定</el-button>
        <el-button @click="dialogShowGameSumClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API_Game from "@/api/sportManage/game";
import {
	formatTime
} from "@/utils/util"

export default {
	name: "gamesIndex",
	components: {
		// baseTab,portTab,wechatTab,inviteTab
	},
	data() {
		return {
			activeName: 'all',
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				isCheck: '',
				time: [],
				applyTime: [],
				gameTime: []
			},
			types: [],
			status: [{
					value: '',
					name: "全部",
				},
				{
					value: '1',
					name: "已结束",
				},
				{
					value: '2',
					name: "进行中",
				},
				{
					value: '3',
					name: "报名中",
				},
			],
			list: [],
			total: 0,
			loading: false,

			dialogShow: false,
			setParams: {},
			selectList: [],
			
			// 赛事总结
			dialogShowGameSum:false,
			gameSumFormRules:{
				gameCompetitionSystem: [
         {
           required: true,
           message: "请输入赛事总结",
           trigger: "blur",
         }
       ]
			},
			gameInfo:{
				gameCompetitionSystem:''
			}
		};
	},
	created() {
		this._getList()
		this._getTypes()
	},
	methods: {

		// 赛事总结
		gameSum(row){
			console.log(row)
			this.gameInfo.id = row.id
    	this._getDetail()
		},

		// 接口-赛事详情
    _getDetail() {
      API_Game.gameInfo({
        id: this.gameInfo.id,
      }).then((res) => {
        this.gameInfo = res.data;
        // this.fileList1.push({ url: res.data.gameImg, name: res.data.gameImg });
        // this.fileList2.push({
        //   url: res.data.orderFile,
        //   name: res.data.orderFile,
        // });
        // this.fileList3.push({
        //   url: res.data.gameRegulationFile,
        //   name: res.data.gameRegulationFile,
        // });
        // this.gameInfo.bmTime = [res.data.applyStartTime, res.data.applyEndTime];
        // this.gameInfo.jbTime = [res.data.gameStartTime, res.data.gameEndTime];
				this.dialogShowGameSum = true
      });
    },

		dialogShowGameSumClose(){
			this.gameInfo = {}
			this.dialogShowGameSum = false
		},

		submitFormGameSum(){
			this.$refs["gameSumForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            // this.gameInfo
            applyStartTime: this.gameInfo.applyStartTime,
            applyEndTime: this.gameInfo.applyEndTime,
            cityNo: "",
            conductHost: this.gameInfo.conductHost,
            contractor: this.gameInfo.contractor,
            detailedAddress: this.gameInfo.detailedAddress,
            gameCompetitionSystem: this.gameInfo.gameCompetitionSystem,
            gameGenre: this.gameInfo.gameGenre,
            gameImg: this.gameInfo.gameImg,
            gameName: this.gameInfo.gameName,
            gameStartTime: this.gameInfo.gameStartTime,
            gameEndTime: this.gameInfo.gameEndTime,
            isApply: "2",
            isDrafts: 2,
            limitQuantity: this.gameInfo.limitQuantity,
            isLimit: "2",
            provinceNo: "",
            townNo: "",
            orderFile:this.gameInfo.orderFile,
            typeItemList: [{ typeId: 3, itemId: 35 }],
            state:3,
            gameRegulationFile:this.gameInfo.gameRegulationFile
          };
					if(this.gameInfo.id){
            data.id = this.gameInfo.id
          }
          console.log(data)
          API_Game.holdMatch(data).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.loading = false;
            this.dialogShowGameSum = false;
          });
        } else {
					this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
		},

		// 编辑赛事
		handleEdit(row){
			this.$router.push({
				path: '/sportManage/games/addGame',
				query: {
					id: row.id,
				},
			})
		},

		// 发布赛事
		addGame(){
			this.$router.push({
				path: '/sportManage/games/addGame'
			})
		},

		// 接口-赛事列表
		_getList() {
			this.loading = true
			API_Game.gameList(this.queryParams).then((res) => {
				console.log(res.data);
				this.loading = false
				this.total = res.data.total;
				this.list = res.data.list;
			}).catch((err) => {

			});
		},
		// 接口-赛事类型列表
		_getTypes() {
			API_Game.getTypes().then((res) => {
				console.log(res.data);
				this.types = res.data
				this.types.unshift({
					id: '',
					gameTypeName: "全部"
				})
				console.log(this.types);

			}).catch((err) => {

			});
		},
		// 接口-删除赛事类型
		_delGame(id) {
			API_Game.gameDel(id).then((res) => {
				console.log(res.data);
				this.$message({
					message: "已删除",
				});
				this.refreshList()
			}).catch((err) => {

			});
		},
		// 接口-审核赛事
		_auditGame() {
			// let arr = this.selectList.map(val => {
			//   console.log(val);
			//   return {
			//     id: val,
			//     isCheck: this.setParams.isCheck,
			//     checkRemark: this.setParams.checkRemark
			//   }
			// })
			// console.log(arr);
			API_Game.gameAudit([this.setParams]).then((res) => {
				this.$message({
					message: "操作成功",
					type: "success",
				});
				this.dialogShow = false
				this.resetQuery()
			}).catch((err) => {

			});
		},
		// 接口-赛事是否显示
		_switchGame(row) {
			console.log(row);
			API_Game.gameEdit({
				id: row.id,
				isEnable: row.isEnable,
			}).then((res) => {
				console.log(res);
				this.$message({
					message: "操作成功",
					type: "success",
				});
			}).catch((err) => {

			});
		},
		// 接口-赛事列表导出
		handleExport() {
			this.download('/biz/match/export', {
				...this.queryParams
			}, `赛事_${new Date().getTime()}.xlsx`)
		},
		// tab切换
		tabChange(tab, event) {
			console.log(tab.index);
			let index = tab.index
			if (index == 0) this.queryParams.isCheck = ''
			if (index == 1) this.queryParams.isCheck = '1'
			if (index == 2) this.queryParams.isCheck = '3'
			if (index == 3) this.queryParams.isCheck = '2'
			this.resetQuery();
		},
		handleQuery() {
			this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
			this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
			this.queryParams.applyStartTime = this.queryParams.applyTime ? this.queryParams.applyTime[0] : "";
			this.queryParams.applyEndTime = this.queryParams.applyTime ? this.queryParams.applyTime[1] : "";
			this.queryParams.gameStartTime = this.queryParams.gameTime ? this.queryParams.gameTime[0] : "";
			this.queryParams.gameEndTime = this.queryParams.gameTime ? this.queryParams.gameTime[1] : "";
			this.queryParams.pageNum = 1;
			this._getList();
		},
		resetQuery() {
			this.$refs["queryForm"].resetFields();
			this.queryParams.startTime = ''
			this.queryParams.endTime = ''
			this.queryParams.applyStartTime = ''
			this.queryParams.applyEndTime = ''
			this.queryParams.gameStartTime = ''
			this.queryParams.gameEndTime = ''
			this.queryParams.time = []
			this.queryParams.applyTime = []
			this.queryParams.gameTime = []
			this.queryParams.pageNum = 1;
			this._getList();
		},
		refreshList() {
			this.queryParams.pageNum = 1;
			this.dialogShow = false
			this._getList();
		},
		handleDtl(row) {
			this.$router.push({
				path: '/sportManage/games/detail',
				query: {
					id: row.id,
				},
			})
		},
		handleDel(row) {
			console.log(row);
			this.$confirm(`确定删除赛事“${row.gameName}”？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					this._delGame(row.id)
				})
				.catch(() => {});
		},
		handleAudit(row) {
			this.dialogShow = true
			this.setParams = {
				isCheck: '3',
				id: row.id
			}
			// this.selectList = [row.id]
			// console.log(this.selectList);
		},
		submitForm() {
			if (this.setParams.isCheck == '2' && !this.setParams.checkRemark) {
				this.$message({
					message: "请填写拒绝原因",
					type: "error",
				});
				return
			}
			this._auditGame()
		},
	},
};
</script>

<style lang="scss">
.gamesIndex {
  padding: 40px 40px;
  color: #676a6c;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}
</style>

<style lang="scss">
@import "../../../assets/styles/common.scss";
</style>
